var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import queryString from 'query-string';
import { Component } from 'react';
import { PromotionInternalChannel } from 'smartpi-core';
import weixinJsSdk from 'weixin-js-sdk';
import { config } from '../config';
var WechatShare = /** @class */ (function (_super) {
    __extends(WechatShare, _super);
    function WechatShare() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = Math.random();
        _this.defaultShareIconLink = config.CDN_DOMAIN + "/web/share/images/lesson-icon.png";
        _this.defaultTitle = '我家宝贝已报名！每天15分钟，跟着哈佛老师学数学';
        _this.defaultDesc = '幼升小数学知识全掌握！';
        _this.defaultShareType = 'link';
        return _this;
    }
    WechatShare.prototype.componentWillUnmount = function () {
        WechatShare.isShareSet = false;
    };
    WechatShare.prototype.checkShareHasSet = function () {
        if (WechatShare.isShareSet && this.id !== WechatShare.id) {
            if (config.DEBUG) {
                throw new Error('share config set more than once');
            }
            else {
                console.warn('share config set more than once');
            }
        }
    };
    WechatShare.prototype.setShare = function (shareParams) {
        var _this = this;
        weixinJsSdk.ready(function () {
            console.debug('[Wechat] Configing wechat share', shareParams);
            weixinJsSdk.onMenuShareTimeline(__assign(__assign({}, shareParams), { 
                // TODO
                success: function () {
                    _this.props.config && _this.props.config.onSuccess && _this.props.config.onSuccess();
                } }));
            weixinJsSdk.onMenuShareAppMessage(__assign(__assign({}, shareParams), { 
                // TODO
                success: function () {
                    _this.props.config &&
                        _this.props.config.onMenuShareAppMessageSuccess &&
                        _this.props.config.onMenuShareAppMessageSuccess();
                } }));
            weixinJsSdk.onMenuShareQQ(__assign({}, shareParams));
            // wx.onMenuShareWeibo({
            // title: title, // 分享标题
            // desc: desc, // 分享描述
            // link: 'congmingpai.com/growth/plan/share/image', // 分享链接
            // imgUrl: logo // 分享图标
            // })
            // wx.onMenuShareQZone({
            //   title: title, // 分享标题
            //   desc: desc, // 分享描述
            //   link: link, // 分享链接
            //   imgUrl: logo // 分享图标
            // })
        });
    };
    WechatShare.prototype.createShareLinkParams = function (options) {
        // 生成落地页参数
        var shareParams = {
            channel: options.channel || PromotionInternalChannel.DEFAULT,
            inviter: options.userUuid,
            extra: options.extra,
            source: 'wechat',
            platform: 'h5',
        };
        var stringifiedShareParams = queryString.stringify(shareParams);
        // 落地页链接
        var shareLandingUrl = config.API_ENDPOINT + "/promotion/go?" + stringifiedShareParams;
        // 分享图标链接
        var shareIconLink = options.shareIconLink || this.defaultShareIconLink;
        return {
            title: options.title || this.defaultTitle,
            desc: options.desc || this.defaultDesc,
            link: shareLandingUrl,
            imgUrl: shareIconLink,
            type: this.defaultShareType,
        };
    };
    WechatShare.prototype.render = function () {
        if (!WechatShare.isShareSet) {
            WechatShare.id = this.id;
        }
        this.checkShareHasSet();
        WechatShare.isShareSet = true;
        var _a = this.props.config || {}, _b = _a.userUuid, userUuid = _b === void 0 ? undefined : _b, _c = _a.extra, extra = _c === void 0 ? undefined : _c, _d = _a.channel, channel = _d === void 0 ? undefined : _d, _e = _a.shareIconLink, shareIconLink = _e === void 0 ? undefined : _e, _f = _a.title, title = _f === void 0 ? undefined : _f, _g = _a.desc, desc = _g === void 0 ? undefined : _g;
        var shareParams = this.createShareLinkParams({
            userUuid: userUuid,
            extra: extra,
            channel: channel,
            shareIconLink: shareIconLink,
            title: title,
            desc: desc,
        });
        this.setShare(shareParams);
        return null;
    };
    WechatShare.isShareSet = false;
    WechatShare.id = 1;
    return WechatShare;
}(Component));
export { WechatShare };
//# sourceMappingURL=WechatShare.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/WechatShare.js
// module id = 1218
// module chunks = 0